import { view } from '@forge/bridge'
import type { History } from 'history'

let historyPromise: Promise<History> | null = null

export function getHistory() {
  if (!historyPromise) {
    historyPromise = view.createHistory()
  }
  return historyPromise
}
